module.exports = __webpack_public_path__ + "static/media/icono_info_medica.4230056d.svg";